export const DEFAULT_CUSTOM_COLUMNS = ["message"];
